import {useMount} from './useMount';

export function useScrollToTopOnMount() {
  useMount(() => {
    window.scrollTo(0, 0);
  });
}
